<template>
  <section
    class="layout-pt-lg layout-pb-lg sec"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
  
    <div class="wm-layer">
      <BlockSymbol
        v-if="vars.watermarkImage"
        :block-logo-image="String(vars.watermarkImage)"
        block-opacity="1"
        position-text="left_top"
        :company-key="company.company_key"
        image-class="wm-size wm-white"
      />
      <BlockSymbol
        v-if="vars.watermark2Image"
        :block-logo-image="String(vars.watermark2Image)"
        block-opacity="1"
        position-text="left_tp"
        :company-key="company.company_key"
        image-class="wm-size "
      />
    </div>

    <div class="container content-layer" :style="`color: var(--c-${vars.textColor})`">
      <div class="tw-mb-8">
        <div v-html="vars.titleHtml || '<h2 class=&quot;tw-text-3xl lg:tw-text-4xl tw-font-semibold&quot;>Summary</h2>'"></div>
      </div>

      <div class="md:tw-hidden tw-space-y-6">
        <div v-for="(card, i) in cards" :key="`m-${i}`" class="tw-space-y-1">
          <h5>{{ card.title }}</h5>
          <p>{{ card.description }}</p>
        </div>
      </div>

      <div class="tw-hidden md:tw-grid md:tw-grid-cols-[max-content_1fr] md:tw-gap-x-96 md:tw-gap-y-6">
        <template v-for="(card, i) in cards" :key="`d-${i}`">
          <div><h5>{{ card.title }}</h5></div>
          <div><p style="color: #D2D2D2 !important;">{{ card.description }}</p></div>
        </template>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'TakeAction',

  components: {
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  data() {
    return {
     
    };
  },

  computed: {
    descriptions(): Array<{ description: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.descriptions || [];
    },
    buttons(): Array<{ link: string; type: string; label: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.buttons || [];
    },
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>


<style scoped>


 

.sec { position: relative; overflow: hidden; }



:deep(.wm-size) {
  width: clamp(1200px, 50vw, 1200px) !important; 
  height: auto !important;
 
}




</style>